// Builds the eval API bound to the shared transport (same pattern as
// draft-preview's getApiClient). Kept in one place so both hooks reuse it.

import { createEvalApi } from '@/entities/eval';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';

export function getEvalApi() {
  return createEvalApi(
    createApiClient({
      baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
      auth: { getToken },
    }),
  );
}
